
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/flag/ship_ai_code_webinar/on/catalog",
      function () {
        return require("private-next-pages/flag/ship_ai_code_webinar/on/catalog/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/flag/ship_ai_code_webinar/on/catalog"])
      });
    }
  